<template>
  <div class="layout-component">
    <div class="sidebar-wrapper" v-if="!$route.loginPage">
      <aside class="main-sidebar">
        <div class="sidebar">
          <ul class="nav sidebar-menu">
            <li v-on:click="toggleSidebar">
              <a class="sidebar-toggle">
                <i class="fa fa-bars fa-fw"></i> <span>Navigation</span>
              </a>
            </li>
            <li v-on:click="closeSidebar" v-link="{ path: '/dashboard' }" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-dashboard"></i> <span>Dashboard</span>
              </a>
            </li>
            <li v-on:click="closeSidebar" v-link="{ path: '/reserve' }" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-calendar-plus-o"></i> <span>New Reservation</span>
              </a>
            </li>
            <li v-on:click="closeSidebar" v-link="{ path: '/my-reservations' }" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-calendar"></i> <span>My Reservations</span>
              </a>
            </li>
            <li v-on:click="closeSidebar" v-link="{ path: '/my-account' }" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-user"></i> <span>Account Details</span>
              </a>
            </li>
            <li v-on:click="closeSidebar" v-link="{ path: '/billing' }" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-credit-card"></i> <span>Billing</span>
              </a>
            </li>
            <li v-on:click="closeSidebar" v-link="{ path: '/report' }" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-exclamation-triangle"></i> <span>Report</span>
              </a>
            </li>
            <li v-on:click="logout" class="interactive-cursor">
              <a>
                <i class="fa fa-fw fa-sign-out"></i> <span>Logout</span>
              </a>
            </li>
          </ul>
        </div>
      </aside>
    </div>
    <div class="mobile-menu-wrapper" v-on:click="toggleSidebar" v-if="!$route.loginPage">
      <a class="sidebar-toggle">
        <i class="fa fa-bars fa-fw"></i> <span>Navigation</span>
      </a>
    </div>
    <div class="content-wrapper" v-on:click="closeSidebar" v-bind:class="{ 'no-margin': $route.loginPage }">
      <div class="logo-banner" v-if="!$route.loginPage">
        <div class="row">
          <div class="col-md-4 col-md-offset-1 col-sm-5 col-sm-offset-1 col-xs-5 col-xs-offset-1">
            <img v-bind:src="'https://techcar-dev.s3.amazonaws.com/'+ ( $root.companyLogo ? $root.companyLogo : 'spacer.gif' ) + '?v=' + new Date().getTime()" v-bind:alt="companyName" />
          </div>
          <div class="col-md-2 col-md-offset-5 col-sm-4 col-sm-offset-2 col-xs-6">
            <div class="contact">
              <h4 class="phone">1300 575 878</h4>
              <button class="btn btn-info" v-link="{path: '/contact'}">Contact</button>
            </div>
          </div>
        </div>
      </div>
      <account-message v-if="!$route.loginPage"></account-message>
      <div class="content">
        <div class="row" v-if="$route.breadcrumbs">
          <div class="col-sm-12">
            <breadcrumbs></breadcrumbs>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
    <footer class="main-footer" v-bind:class="{ 'no-margin': $route.loginPage }" v-if="!$route.noFooter">
      <div class="form-footer">
        <h2>Contact</h2>
        <p><strong>GreenShareCar</strong><br>Tel: 1300 575 878<br>Email: <a href="mailto:info@greensharecar.com.au">info@greensharecar.com.au</a></p>
      </div>
      <strong>Copyright &copy; {{ year }} <a href="http://www.greensharecar.com.au">Powered by GreenShareCar</a>.</strong> All rights
        reserved.
    </footer>
  </div>
</template>

<script>
import AccountMessage from '../displays/AccountMessage.vue'
import Breadcrumbs from './Breadcrumbs.vue'

export default {
  name: 'PublicLayout',
  components: {
    AccountMessage,
    Breadcrumbs
  },
  data () {
    return {
      account: {},
      year: moment().year()
    }
  },
  route: {
    data () {
      if (!this.$route.loginPage) {
        this.$http.get('private/user', {}).then(({ data }, status, request) => {
          this.account = data.account
        })
      }
    }
  },
  methods: {
    logout (e) {
      this.$http.get('public/logout', {}).then(({ data }, status, request) => {
        this.$http.headers.common.Authorization = false
        window.sessionStorage.removeItem('token')
        this.closeSidebar()
        this.$route.router.go('/')
      })
    },
    toggleSidebar () {
      if ($('body').hasClass('sidebar-collapse')) {
        $('body').addClass('sidebar-open').removeClass('sidebar-collapse')
      } else {
        this.closeSidebar()
      }
    },
    closeSidebar () {
      $('body').removeClass('sidebar-open').addClass('sidebar-collapse')
    }
  }
}
</script>



// WEBPACK FOOTER //
// Layout.vue?544ae54c